<template>
  <Head title="Register senha" />
  <GuestLayout>
    <article >
      <div class="sm:px-5 xl:max-w-[350px] xl:min-w-[350px]">
        <HeadingGuest title="Nome" />
        <p class="pb-2">Qual é o seu primeiro nome?</p>

        <form @submit.prevent="submit">
          <ul class="grid gap-14 pt-4">
            <li>
              <label class="mb-1 mr-5 flex font-semibold">
                Primeiro Nome
              </label>
              <Input
                placeholder="Preencha o seu nome aqui..."
                type="text"
                required
                v-model="form.firstName"
              />
            </li>

            <li>
              <button
                class="
                  w-full
                  grid
                  justify-items-center
                  items-center
                  text-primary
                  border-primary border rounded
                  hover:bg-gray-300
                     hover:border-transparent
                  font-semibold
                  p-1.5
                "
              >
                Avançar
              </button>
            </li>
          </ul>
        </form>
      </div>
    </article>
  </GuestLayout>
</template>

<script>
import Input from "@/Components/UI/Form/Input.vue";
import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue"

export default {

  components: {
    Input,
    Label,
    ValidationErrors,
    Head,
    Link,
    GuestLayout,
    HeadingGuest
  },

  data() {
    return {
      form: this.$inertia.form({
        firstName: "",
      }),
    };
  },

  methods: {
    submit() {
      sessionStorage.setItem('name', this.form.firstName);
      location.href = "/register/segundo-nome";
    },
  },
};
</script>
